import { z } from 'zod';

import { VALIDATION_MESSAGES } from '@/constants/constant';

export const parentProfileSchema = z.object({
  fullName: z
    .string()
    .trim()
    .min(1, VALIDATION_MESSAGES.fullName.required)
    .min(2, VALIDATION_MESSAGES.fullName.min)
    .max(100, VALIDATION_MESSAGES.fullName.max),

  phone: z.string().trim().min(1, VALIDATION_MESSAGES.mobileNumber.required),
  countryCode: z.string().optional(),

  relationship: z.string().optional(),
});

export type TParentProfileForm = z.infer<typeof parentProfileSchema>;
